import React, { useState, useEffect } from 'react';
import { Card, Col, Row, Slider, Select, InputNumber } from 'antd';

const { Option } = Select;


const MultiplicationProblemSettings = (props) => {
    const [settings, setSettings] = useState({ numberOfProblems: props.numberOfProblems, multiplicand_start: props.multiplicand_start, multiplicand_end: props.multiplicand_end,  multiplier_start: props.multiplier_start, multiplier_end: props.multiplier_end })

    const onSliderValueChange = (key, value) => {
        setSettings({ ...settings, [key]: value })
    }

    useEffect(() => {
        props.onChange(settings)
    }, [settings])

    return <>
            <div class="display-settings-row">
                <Row>
                    <Col>
                        <span class="label">Number of Problems</span>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Slider
                            min={10}
                            max={50}
                            onChange={(value) => onSliderValueChange('numberOfProblems', value)}
                            value={typeof settings.numberOfProblems === 'number' ? settings.numberOfProblems : 0}
                        />
                    </Col>
                </Row>
            </div>
            <div class="display-settings-row">
                <Row class="label">
                    <Col>
                        <span class="label">Multiplicand (start - end)</span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <InputNumber min={1} max={1000} defaultValue={settings.multiplicand_start} onChange={(value) => onSliderValueChange('multiplicand_start', value)} /> -
                    </Col> 
                    <Col>
                        <InputNumber min={1} max={100000} defaultValue={settings.multiplicand_end} onChange={(value) => onSliderValueChange('multiplicand_end', value)} />
                    </Col>
                </Row>
            </div>
            <div class="display-settings-row">
                <Row class="label">
                    <Col>
                        <span class="label">Multiplier (start - end)</span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <InputNumber min={1} max={1000} defaultValue={settings.multiplier_start} onChange={(value) => onSliderValueChange('multiplier_start', value)} /> -
                    </Col> 
                    <Col>
                        <InputNumber min={1} max={100000} defaultValue={settings.multiplier_end} onChange={(value) => onSliderValueChange('multiplier_end', value)} />
                    </Col>
                </Row>
            </div>
    </>;
}

export default MultiplicationProblemSettings;

/*
font-family: 'Cutive Mono', monospace;
font-family: 'Dancing Script', cursive;
font-family: 'DotGothic16', sans-serif;
font-family: 'Indie Flower', cursive;
font-family: 'Poppins', sans-serif;
font-family: 'Roboto', sans-serif;
font-family: 'Sacramento', cursive;
font-family: 'Shadows Into Light', cursive;
font-family: 'Teko', sans-serif;
*/